export const REMOVE_VOUCHER_KEY = "removeVoucher";
export const BOOKING_QUERY_KEY = "BOOKING";
